export default "__VITE_ASSET__BoYEIDl9__"